module.exports = __webpack_public_path__ + "static/media/default-video.da9fd93a.png";